import React, { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('ready'); // Default to ready for simpler UI
  const { addNotification } = useApp();
  const navigate = useNavigate();

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      addNotification('Password must be 6+ characters.', 'error');
      return;
    }

    setLoading(true);
    try {
      // Supabase handles the token automatically if it's in the URL hash
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      
      addNotification('Password updated successfully!', 'success');
      window.isBypassActive = false;
      navigate('/profile');
    } catch (err) {
      addNotification(err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 flex items-center justify-center min-h-[70vh]">
      <div className="w-full max-w-md bg-slate-850 p-8 rounded-3xl border border-slate-800 shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-amber-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-amber-500/20">
            <SafeIcon icon={FiIcons.FiLock} className="text-3xl text-amber-500" />
          </div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Set Private Password</h2>
          <p className="text-slate-400 text-sm mt-1">Enter a new secure password for your admin account.</p>
        </div>

        <form onSubmit={handleUpdate} className="space-y-4">
          <div className="relative">
            <SafeIcon icon={FiIcons.FiKey} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
            <input 
              required 
              type="password" 
              placeholder="New Password (6+ characters)" 
              className="w-full bg-slate-900 border border-slate-700 rounded-xl p-4 pl-12 text-white outline-none focus:ring-2 focus:ring-amber-500/50" 
              value={password} 
              onChange={e => setPassword(e.target.value)}
              autoFocus
            />
          </div>
          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-400 text-slate-900 font-extrabold py-4 rounded-xl shadow-lg transition-all flex items-center justify-center space-x-2"
          >
            {loading ? <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" /> : null}
            <span>Save & Upgrade Account</span>
          </button>
        </form>
      </div>
    </div>
  );
}